export const newRelicErrorLog = (
  errorObj,
  extraAttributes = {},
  errorMessage = ""
) => {
  if (process.env.REACT_APP_ENVIRONMENT === "production") {
    let error;
    if (errorObj instanceof Error) {
      error = errorObj;
    } else {
      error = new Error(errorMessage || "Unexpected Error");
      error.original = errorObj;
    }

    if (!error.message) {
      error.message = errorMessage || "Unexpected Error";
    }

    error.dealershipId = extraAttributes?.dealershipId || null;
    error.recordingSessionId = extraAttributes?.recordingSessionId || null;
    error.originated = extraAttributes?.originated || null;

    if (window.newrelic && typeof window.newrelic.noticeError === "function") {
      try {
        window.newrelic.noticeError(error);
      } catch (e) {
        console.error("Failed to send error to New Relic:", e, error);
      }
    } else {
      console.error("New Relic not available:", error);
    }
  }
};
